export function maskBlobToken(token: string): string {
  const match = /^(vercel_blob_rw_[A-Za-z0-9]+)_/.exec(token)
  if (match) return `${match[1]}_***`
  return `${token.slice(0, 8)}***`
}
